import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";

import { useAccountStore } from "base/stores";

import { CommentWrapper } from "../comment";
import { ReactionWrapper } from "../reaction";
import { useCommentStore } from "../../common/store/comment.store";

CommentReactionWrapper.propTypes = {
  teamId: PropTypes.string,
  medium: PropTypes.string,
  mediumId: PropTypes.string,
  instanceId: PropTypes.string,
  instanceType: PropTypes.string,
  entityType: PropTypes.string,
  entityId: PropTypes.string,
  creatorId: PropTypes.string,
  isComment: PropTypes.bool,
  seenCount: PropTypes.number,
  postNotification: PropTypes.object,
  focusedNotification: PropTypes.object,
  postMentions: PropTypes.array,
  roles: PropTypes.array,
  shouldCallDefaultComments: PropTypes.bool,
  updateBookmarkList: PropTypes.func
};

export function CommentReactionWrapper(props) {
  const {
    teamId,
    medium,
    mediumId,
    instanceId,
    instanceType,
    entityId,
    entityType,
    isComment,
    postNotification,
    focusedNotification,
    postMentions,
    shouldCallDefaultComments = true
  } = props;

  useEffect(
    function getPostComment() {
      if (
        instanceId &&
        shouldCallDefaultComments &&
        !(
          postNotification &&
          postNotification.notificationData[0].Properties.CommentId
        ) &&
        !(focusedNotification && focusedNotification.Properties.CommentId)
      ) {
        const params = {
          medium,
          teamId,
          mediumId,
          instanceType,
          instanceId,
          entityType,
          entityId,
          accountId: useAccountStore.getState()._id
        };
        let { getComments } = useCommentStore.getState();
        getComments(params);
      }
    },
    [instanceId, focusedNotification, postNotification]
  );

  return (
    <Fragment>
      <ReactionWrapper {...props} />
      <CommentWrapper
        {...props}
        isComment={isComment}
        postNotification={postNotification}
        focusedNotification={focusedNotification}
        postMentions={postMentions}
      />
    </Fragment>
  );
}
